import type { ArenaAction } from '@guildrise/shared';

export function ActionIcon({ action }: { readonly action: ArenaAction }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width="30"
      height="30"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <title>{action}</title>
      {action === 'secret' ? (
        <>
          <rect x="7" y="3" width="18" height="26" rx="3" />
          <path d="m16 10 5 6-5 6-5-6Z" />
        </>
      ) : action === 'discard' ? (
        <>
          <rect x="8" y="3" width="16" height="22" rx="3" />
          <path d="m12 10 8 8m0-8-8 8M5 29h22" />
        </>
      ) : action === 'gift' ? (
        <>
          <rect x="2" y="10" width="8" height="16" rx="2" />
          <rect x="12" y="10" width="8" height="16" rx="2" />
          <rect x="22" y="10" width="8" height="16" rx="2" />
          <path d="M16 7V1m-3 3 3-3 3 3" />
        </>
      ) : (
        <>
          <rect x="2" y="4" width="10" height="15" rx="2" />
          <rect x="6" y="12" width="10" height="16" rx="2" />
          <rect x="18" y="4" width="10" height="15" rx="2" />
          <rect x="22" y="12" width="8" height="16" rx="2" />
        </>
      )}
    </svg>
  );
}
